module.exports = __webpack_public_path__ + "static/media/RP_1600golf.516351bd.jpg";